<template>
  <div class="menu">
    <h1>Categorias</h1>
    <TreeBrowser :node="root"/>
  </div>
</template>

<script>
  import TreeBrowser from './TreeBrowser';

  const computed = {
    root() {
      return this.$store.getters.root
    }
  }

  export default {
    name: 'MenuCategories',
    computed,
    components: {
      TreeBrowser
    }
  }
</script>

<style>
  .menu {
    border: 1px solid #ddd;
    border-radius: 1rem;
    margin: 0;
    padding: 0;
  }

  h1 {
    background-color: #008acc;
    color: #fff;
    font-weight: bold;
    text-transform: uppercase;    
  }

  ul {
    width: auto;
  }

  li {
    padding: 10px 5px;
    display: grid;
    width: auto;
  }

  a {
    text-decoration: none;
    color: #777;
    padding: 10px 5px;
  }

  a:hover {
    background-color: #08c;
    color: #fff;
    transition: all .3s;
  }
</style>
